enum InvoiceLineStatus {
	INITIAL = 'initial',
	FILLED = 'filled',
	CHECKED = 'checked',
	INVOICED = 'invoiced'
}

export default InvoiceLineStatus
